_collow.components.CodeBlock = class CodeBlock extends _collow.components.Base {
  root;
  elements;
  params;
  codeMirrorInstance;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;
    // Load mode scripts and then initialize CodeMirror
    this.loadModeScripts()
        .then(() => {
          this.loadCodeMirror();
        })
        .catch((error) => {
          console.error("Failed to load mode scripts:", error);
        });
  }



  /** Mapping for script loading */
  static scriptModeMap = {
    html: ["htmlmixed", "xml", "css", "javascript"], // Dependencies for htmlmixed
    mysql: ["sql"],
    json: ["javascript"], // JSON uses the JavaScript mode
    typescript: ["javascript"], // TypeScript uses the JavaScript mode
    golang: ["go"],
    csharp: ["clike"],
    java: ["clike"],
    scss: ["css"],
  };

  /** Mapping for CodeMirror mode configuration */
  static modeMap = {
    html: "htmlmixed",
    mysql: "text/x-mysql",
    json: { name: "javascript", json: true },
    typescript: "text/typescript",
    golang: "text/x-go",
    csharp: "text/x-csharp",
    java: "text/x-java",
    scss: "text/x-scss",
  };

  /**
   * Dynamically loads mode scripts for the given language.
   * @returns {Promise} Resolves when all scripts are successfully loaded.
   */
  loadModeScripts() {
    const language = this.params.language;
    const modes = CodeBlock.scriptModeMap[language] || [language];

    // Return a Promise that resolves when all scripts are loaded
    return Promise.all(
        modes.map((mode) =>
            new Promise((resolve, reject) => {
              const script = document.createElement("script");
              script.src = `https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.65.7/mode/${mode}/${mode}.min.js`;

              script.onload = resolve; // Resolve the promise when the script is loaded
              script.onerror = () => reject(`Failed to load mode script: ${script.src}`);

              document.head.appendChild(script);
            })
        )
    );
  }

  /**
   * Initializes CodeMirror with the specified configuration.
   */
  loadCodeMirror() {
    let code = this.params.code;

    // Pretty-print JSON if applicable
    if (this.params.language === "json" && typeof code !== "string") {
      code = JSON.stringify(code, null, 2);
    }

    // Initialize CodeMirror
    this.codeMirrorInstance = CodeMirror(this.root, {
      lineNumbers: true,
      tabSize: 2,
      value: code.trimEnd(),
      mode: CodeBlock.modeMap[this.params.language] || this.params.language,
      theme: "monokai",
      gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
      autoRefresh: true,
      lineWrapping: true,
      readOnly: true,
    });
  }
};